import { reducer as loadingState } from './loadingStates';
import { reducer as confirmBox } from './confirmBox';
import { reducer as froala } from './froala';

// This reducer is useful for checking optimization of the digest cycle on Angular side (see redux-store-service).
const lastActionType = (state, action) => action.type;

export default { confirmBox, froala, lastActionType, loadingState };
